import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let currentUser = localStorage.getItem('currentUser') || false;

        if (currentUser) {
            request = request.clone({
                setHeaders: {
                    Authorization: currentUser
                }
            });
        }

        return next.handle(request).pipe(tap(() => { },
            (err: any) => {
                console.log(err);
                
                if (err instanceof HttpErrorResponse) {
                    if (err.status !== 400) {
                        return;
                    }
                    this.router.navigate(['']);
                }
            })
        );
    }
}